import StudyLevel from '@/models/StudyLevel';
import StudyOption from '@/models/StudyOption';

const LOAD_STUDY_RESOURCES = 'load_study_resources';

const LOAD_STUDY_RESOURCES_REQUEST = 'load_study_resources_request';
const LOAD_STUDY_RESOURCES_SUCCESS = 'load_study_resources_success';
const LOAD_STUDY_RESOURCES_ERROR = 'load_study_resources_error';

export { LOAD_STUDY_RESOURCES };

export default {
    state: {
        loading: false,
        study_levels: [],
        study_options: [],
    },
    mutations: {
        [LOAD_STUDY_RESOURCES_REQUEST] (state) {
            state.loading = true;
        },
        [LOAD_STUDY_RESOURCES_SUCCESS](state, { study_levels, study_options }) {
            state.loading = false;
            state.study_levels = study_levels;
            state.study_options = study_options;
        },
        [LOAD_STUDY_RESOURCES_ERROR] (state, errors) {
            state.loading = false;
        }
    },
    actions: {
        [LOAD_STUDY_RESOURCES] ({ commit, state }) {
            commit(LOAD_STUDY_RESOURCES_REQUEST);

            let study_levels_promise = StudyLevel.collection();
            let study_options_promise = StudyOption.collection();

            Promise.all([study_levels_promise, study_options_promise])
                .then(values => {
                    commit(LOAD_STUDY_RESOURCES_SUCCESS, {
                        study_levels: values[0].items.filter(item => item.name != null),
                        study_options: values[1].items,
                    });
                }).catch(({ status, errors }) => {
                    commit(LOAD_STUDY_RESOURCES_ERROR, errors);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/study-resources.js